<template>
	<a-button type="primary" style="width:120px" :disabled="!isuse" @click="getcode">{{msg}}</a-button>
</template>
<script>
import {message} from 'ant-design-vue'
import {sendmsg} from '@/api/manager'
export default {
	data(){
		return {
			msg:"获取验证码",
			isuse:true,
		}
	},
	props:[
		"phone",
		"id"
	],
	methods:{
		getcode(){
			let reg = /^1[0-9]{10}$/
			if(!reg.test(this.phone)){
				message.error("请输入正确的手机号码",1)
				return false
			}
			console.log("id",this.id,this.phone)
			sendmsg({id:this.id,phone:this.phone}).then(ret=>{
				console.log(ret)
			})
			this.isuse = false
			this.msg = 60
			let time =  setInterval(()=>{
				this.msg = this.msg -1
				if(this.msg == 1){
					this.msg = "获取验证码"
					this.isuse  = true
					clearInterval(time)
				}
			},1000)
		}
	}
}
</script>

